module.exports = __webpack_public_path__ + "media/Gif2.7936ac5b.mp4";